/**
 * Central brand constants for the CollectorUp platform.
 *
 * CollectorUp is the primary public brand. The platform was created by
 * Gil Maakaroun and continues to be independently operated by him — that
 * relationship is surfaced as a small subtitle wherever the platform name
 * appears, and via all certificate/inspector copy across the site.
 *
 * Rules:
 *   • `PLATFORM_NAME` is always the visually dominant brand
 *   • `CREATOR_NAME` is the subtitle / attribution / inspector
 *   • `SUPPORT_EMAIL` is the ONLY public contact address for the platform
 *   • `SITE_ORIGIN` is the canonical customer-facing domain
 *
 * Do NOT expose any admin address or `@gilmaakaroun.com` mailbox in
 * public UI. Internal admin logins remain unchanged.
 */

export const PLATFORM_NAME = "CollectorUp";
export const CREATOR_NAME = "Gil Maakaroun";
export const CREATOR_SUBTITLE = "Created by Gil Maakaroun";
export const SUPPORT_EMAIL = "support@collectorup.com";
export const SITE_ORIGIN = "https://collectorup.com";
export const PLATFORM_TAGLINE = "The World Cup Collector Registry";
